module.exports = "https://static.wmbcdn.com/uniweb/images/72e1b7b751eb84fe632386a6b9db9ed2.svg";